import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ height: "100%" }} // Deixa o conteúdo ocupar o espaço restante
    >
      {value === index && <Box sx={{ p: 0, height: "100%" }}>{children}</Box>}
    </div>
  );
}

export default function MenuTabs({
  tabs = [
    { label: "teste1", content: "teste1 conteúdo", id: 1 },
    { label: "teste2", content: "teste2 conteúdo", id: 2 },
  ],
  width = "100%",
  height = "calc(100% - 88px)", // Altura ajustada para o componente
  value,
  setValue,
}) {
  const hasTabs = !!tabs && Array.isArray(tabs) && tabs.length > 0;

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const idOfTab = tabs[newValue].id;
    window.localStorage.setItem(
      "idSelectedTabCallCenter",
      JSON.stringify(idOfTab)
    );
  };

  return (
    <Box sx={{ width, height, display: "flex", flexDirection: "column" }}>
      {/* Flexbox para organizar a altura */}
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
      >
        {tabs.map((tab, index) => (
          <Tab
            key={`tab--${index}`}
            label={tab.label}
            /*
              text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.1px;
          */
            sx={{
              width: "180px",
              textAlign: "center",
              fontFamily: "'Inter', sans-serif",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px",
              letterSpacing: "0.1px",
              borderBottom: "1px solid #e5e7eb",
              "&.Mui-selected": {
                color: "#455cc7",
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#455cc7",
              },
            }}
          />
        ))}
      </Tabs>
      <Box sx={{ height: "calc(100% - 48px)" }}>
        {" "}
        {/* Esse Box agora ocupa o restante da altura */}
        {tabs.map((tab, index) => (
          <CustomTabPanel
            key={`custom-tab-panel--${index}`}
            value={value}
            index={index}
          >
            {tab.content}
          </CustomTabPanel>
        ))}
      </Box>
    </Box>
  );
}
